(() => {
  const appSel = "#__next";

  const beforeId = "skio_bab_container";
  const afterId = "after_box";

  const beforeHTML = `
    <div id="${beforeId}" class="shopify-section section-rich-text">
      <div class="article use-alt-bg fully-padded-row--medium">
        <div class="container">
          <div class="align-center spaced-column">
            <div class="rte lightly-spaced-row large-text">
              <p>
                Design your own bundle with a <strong>minimum of 3 products</strong> and get
                <strong>up to 20%</strong> discount!<br><br>
                Order your bundle as a <strong>one-time purchase</strong>, or
                <strong>subscribe</strong> to get it delivered to you every 1, 2, or 3 months.
              </p>
            </div>
            <div class="rte lightly-spaced-row">
              <p>
                Order 3 products 👉🏼 Get 10% off<br>
                Order 4+ products 👉🏼 Get 15% off<br>
                Order 7+ products 👉🏼 Get 20% off
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  `.trim();

  const afterHTML = `
    <div id="${afterId}" class="shopify-section section-rich-text">
      <div class="article use-alt-bg fully-padded-row--medium">
        <div class="container">
          <div class="align-center spaced-column">
            <div class="rte lightly-spaced-row ">
              <p><em>You can pause, continue, or cancel your bundle subscription at any time!</em></p>
            </div>
            <div class="rte lightly-spaced-row ">
              <p><em>Please note that discount codes cannot apply on this page. </em></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;

  const insert = () => {
    const next = document.querySelector(appSel);
    if (!next) return false;

    if (!document.getElementById(beforeId)) next.insertAdjacentHTML("beforebegin", beforeHTML);
    if (!document.getElementById(afterId)) next.insertAdjacentHTML("afterend", afterHTML);

    return true;
  };

  if (insert()) return;

  const obs = new MutationObserver(() => insert() && obs.disconnect());
  obs.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(() => obs.disconnect(), 15000);
})();